module.exports = ".ck.ck-menu-bar__menu{display:block;position:relative;font-size:inherit}.ck.ck-menu-bar__menu.ck-menu-bar__menu_top-level{max-width:100%}"